import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { isUserFinancier } from 'utils/auth';
import { ContractAnalysis } from './ContractAnalysis';
import FileAccessGrant from './FileAccessGrant';

const Ctes = lazy(() => import('./Ctes'));
const ProposalsManagement = lazy(() => import('./ProposalsManagement'));
// const LimitsConcentrationControl = lazy(() => import('./LimitsConcentrationControl'));
// const Leads = lazy(() => import('./Leads'));
const UserDetails = lazy(() => import('./Users/UserDetails'));
const ContractControl = lazy(() => import('./ContractControl'));
// const CreditRiskControl = lazy(() => import('./CreditRiskControl'));
const CreateUser = lazy(() => import('./CreateUser'));
const CreateCarrier = lazy(() => import('./CreateCarrier'));
// const SecondaryOperation = lazy(() => import('./SecondaryOperation'));
// const SecondaryOperationDetails = lazy(() => import('./SecondaryOperation/Details'));
// const ReceiptCharge = lazy(() => import('./ReceiptCharge'));
// const ReceiptChargeComment = lazy(() => import('./ReceiptCharge/Comment'));
const TakersManagement = lazy(() => import('./TakersManagement'));
const TakerCreate = lazy(() => import('./TakersManagement/Create'));
const TakerEdit = lazy(() => import('./TakersManagement/Edit'));
const RevenueManagement = lazy(() => import('./RevenueManagement'));
const RevenueConciliation = lazy(() => import('./RevenueManagement/Conciliation'));
const CarrierManagement = lazy(() => import('./CarrierManagement'));
const CarrierDetails = lazy(() => import('./CarrierManagement/CarrierDetails'));
const EligibilityCriteriasManagement = lazy(() => import('./Ctes/EligibilityCriteriasManagement'));
const ContaRecebimento = lazy(() => import('./Arrecadacao/ContaRecebimento'));
const Vencimento = lazy(() => import('./Arrecadacao/Vencimento'));
const Cobranca = lazy(() => import('./Arrecadacao/Cobranca'));
const ArrecadacaoRetiradaManual = lazy(() => import('./Arrecadacao/RetiradaManual'));
const AdvanceLimit = lazy(() => import('./GestaoLimite/AdvanceLimit'));
const GuaranteeNeed = lazy(() => import('./GestaoLimite/GuaranteeNeed'));
const Financiador = lazy(() => import('./Participantes/Financier'));
const FinanciadorCreate = lazy(() => import('./Participantes/Financier/CreateFinancier'));
const FinanciadorDetails = lazy(() => import('./Participantes/Financier/EditFinancier'));
const ParceiroWhiteLabel = lazy(() => import('./Participantes/ParceiroWhiteLabel'));
const ParticipantesUsuarios = lazy(() => import('./Participantes/Usuarios'));
const BankingAccounts = lazy(() => import('./BankingAccounts'));

const AdminRoutes = () => {
  const isFinancierUser = isUserFinancier();

  return (
    <Routes>
      <Route index element={<Navigate to="/admin/processamento-propostas" replace />} />
      <Route path="risco-credito" element={<Navigate to="/admin/gestao-limite" replace />} />
      <Route path="processamento-propostas" element={<ProposalsManagement />} />
      <Route path="processamento-propostas/limites-concentracao/:id" element={<ContractAnalysis.LimitsConcentration />} />
      <Route path="processamento-propostas/atipicidade/:id" element={<ContractAnalysis.Atypicality />} />
      <Route path="processamento-propostas/registros/:id" element={<ContractAnalysis.Registers />} />
      <Route path="processamento-propostas/notificacao-tomadores/:id" element={<ContractAnalysis.ContractTakersNotification />} />
      <Route path="leads" element={<Navigate to="/admin/processamento-propostas" replace />} />
      <Route path="usuarios" element={<Navigate to="/admin/participantes/usuarios" replace />} />
      <Route path="usuarios/:id" element={<UserDetails />} />
      <Route path="usuarios/novo" element={<CreateUser />} />
      <Route path="controle-contratacao" element={<ContractControl />} />
      <Route path="controle-limites-concentracao" element={<Navigate to="/admin/processamento-propostas" replace />} />
      <Route path="transportadoras/novo" element={<CreateCarrier />} />
      <Route path="ctes/monitoramento" element={<Ctes />} />
      <Route path="ctes/criterios-elegibilidade" element={<EligibilityCriteriasManagement />} />
      <Route path="operacoes-secundarias/:id" element={<Navigate to="/admin/processamento-propostas" replace />} />
      <Route path="operacoes-secundarias" element={<Navigate to="/admin/processamento-propostas" replace />} />
      <Route path="recebimento-cobranca" element={<Navigate to="/admin/arrecadacao/vencimento" replace />} />
      <Route path="recebimento-cobranca/:flag/:id" element={<Navigate to="/admin/arrecadacao/vencimento" replace />} />
      <Route path="tomadores" element={<TakersManagement />} />
      <Route path="tomadores/novo" element={<TakerCreate />} />
      <Route path="tomadores/:id" element={<TakerEdit />} />
      <Route
        path="arrecadacao"
        element={isFinancierUser ? <Navigate to="/admin/arrecadacao/vencimento" replace /> : <RevenueManagement />}
      />
      <Route
        path="arrecadacao/:revenueId/conciliacao"
        element={isFinancierUser ? <Navigate to="/admin/arrecadacao/vencimento" replace /> : <RevenueConciliation />}
      />
      <Route
        path="arrecadacao/conta-recebimento"
        element={isFinancierUser ? <Navigate to="/admin/arrecadacao/vencimento" replace /> : <ContaRecebimento />}
      />
      <Route path="arrecadacao/vencimento" element={<Vencimento />} />
      <Route path="arrecadacao/cobranca" element={<Cobranca />} />
      <Route
        path="arrecadacao/retirada-manual"
        element={isFinancierUser ? <Navigate to="/admin/arrecadacao/vencimento" replace /> : <ArrecadacaoRetiradaManual />}
      />
      <Route
        path="gestao-limite"
        element={isFinancierUser ? <Navigate to="/admin/gestao-limite/necessidade-garantia" replace /> : <AdvanceLimit />}
      />
      <Route path="gestao-limite/necessidade-garantia" element={<GuaranteeNeed />} />
      <Route path="participantes/financiador" element={<Financiador />} />
      <Route path="participantes/financiador/novo" element={<FinanciadorCreate />} />
      <Route path="participantes/financiador/:id" element={<FinanciadorDetails />} />
      <Route path="participantes/parceiro-white-label" element={<ParceiroWhiteLabel />} />
      <Route path="participantes/usuarios" element={<ParticipantesUsuarios />} />
      <Route
        path="participantes/contas"
        element={isFinancierUser ? <Navigate to="/admin/processamento-propostas" replace /> : <BankingAccounts />}
      />
      <Route path="transportadoras" element={<CarrierManagement />} />
      <Route path="transportadoras/:id" element={<CarrierDetails />} />
      <Route path="contas-digitais" element={<Navigate to="/admin/participantes/contas" replace />} />
      <Route
        path="acesso-gestao-documentacao"
        element={isFinancierUser ? <Navigate to="/documentacao/gerenciamento" replace /> : <FileAccessGrant />}
      />
    </Routes>
  );
};

export default AdminRoutes;
